module.exports = __webpack_public_path__ + "static/img/companyLogo.319eecf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/companyLogo.png
// module id = nrln
// module chunks = 1